/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import Arrow from 'SVGPath/down-chevron.svg'

const CellItem = ({
  label,
  value = '',
  hasArrow = false,
  children,
  clickHandler,
  isPWA = true,
  isFlexStart = false,
  childClass = null,
  boldValue = false,
  valueClass = null,
  isLowerLabelMin = false,
  strikeoffAmount = false,
  upgradeDetails = {},
  bottomText = ''
}) => (
    <React.Fragment>
      <div className="flex-1">
        <If condition={label}>
          <div
            className={`flex ${isFlexStart ? 'flex-start flex-middle' : 'flex-between'} ${childClass ||
              (isPWA ? 'fs-15' : 'fs-body')}`}
        >
            <p className={`${isLowerLabelMin ? 'min-max-35' : 'min-40'} pr-2 color-8a`}>
              {label}
          </p>
            <div
              className={`flex-1 flex ${isPWA?' ta-r flex-right':''} ${
                isFlexStart ? 'flex-start' : 'flex-end'
                } flex-middle`}
            >
              <If condition={children}>
                {children}
                <Else />
                {strikeoffAmount ? (
                  <><span style={isPWA ? { color: '#339902', marginRight: '4px' } : { color: '#46991A', marginRight: '7px' }} className={`us-text ${boldValue ? 'fw-600' : ''} ${valueClass || ''}`}>{value}</span>
                    <span className={`us-text ${boldValue ? 'fw-600' : ''} td-line-through`}>{valueClass ? strikeoffAmount : strikeoffAmount}</span>
                  </>
                ) :
                  <p className={`us-text ${boldValue ? 'fw-600' : ''} ${valueClass || ''}`}>{value}
                    {upgradeDetails && upgradeDetails.type &&
                      <span className="ml-1">{upgradeDetails.icon}</span>
                    }

                  </p>}
              </If>
              <If condition={hasArrow}>
                <div className="pl-4" onClick={clickHandler}>
                  <Arrow className="right-arrow" />
                </div>
              </If>
            </div>
          </div>
      </If>
      <If condition={bottomText !== ''}>
        <p
          className={`color-8a pt-2 ${isPWA ?
            'fs-11 ta-right' :
            'fs-caption-2 ta-left'
            }`}
        >
          {bottomText}
        </p>
      </If>
      </div>
    </React.Fragment>
  )

const ListWrapper = ({ children, noBorder, isRelatedRow, extraPadding }) => (
  <li
    className={`flex flex-between flex-middle py-1 ${extraPadding ? 'px-8' : ''} ${
      isRelatedRow ? 'pr-4' : 'pl-4 pr-7'
      } ${noBorder ? '' : 'border-bottom-grey'}`}
    style={{minHeight:'58px'}}
  >
    {children}
  </li>
)
const CellWrapper = ({ children, noBorder, isRelatedRow, extraPadding, extraSpacing }) => (
  <div
    className={`flex flex-between flex-middle py-1 ${extraPadding ? 'px-8' : ''}  ${
      extraSpacing ? 'pb-3' : ''
      } ${isRelatedRow ? 'pr-4' : 'pl-4 pr-7'} ${noBorder ? '' : 'border-bottom-grey'}`}
      style={{minHeight:'58px'}}
  >
    {children}
  </div>
)
const RowItem = props => {
  let { type, strikeoffAmount = false } = props
  const { noBorder, isRelatedRow, extraPadding, extraSpacing } = props
  type = type || 'individual_cell'
  let returnItem = null
  switch (type) {
    case 'list':
      returnItem = (
        strikeoffAmount ? (
          <ListWrapper isRelatedRow={isRelatedRow} noBorder={noBorder} extraPadding={extraPadding}>
            <CellItem {...props} />
          </ListWrapper>
        ) : (
            <ListWrapper isRelatedRow={isRelatedRow} noBorder={noBorder} extraPadding={extraPadding}>
              <CellItem {...props} />
            </ListWrapper>
          ))
      break
    default:
    case 'individual_cell':
      returnItem = (
        <CellWrapper
          isRelatedRow={isRelatedRow}
          noBorder={noBorder}
          extraPadding={extraPadding}
          extraSpacing={extraSpacing}
        >
          <CellItem {...props} />
        </CellWrapper>
      )
      break
    case 'dynamic':
      returnItem = (
        <CellWrapper isRelatedRow={isRelatedRow} noBorder={noBorder}>
          <CellItem {...props} />
        </CellWrapper>
      )
      break
  }
  return returnItem
}
RowItem.defaultProps = {
  label: null,
  value: null,
  hasArrow: false,
  isRelatedRow: false,
  clickHandler: () => { },
  leftItem: null,
  rightItem: null
}
RowItem.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hasArrow: PropTypes.bool,
  isRelatedRow: PropTypes.bool,
  clickHandler: PropTypes.func,
  leftItem: PropTypes.element,
  rightItem: PropTypes.element,
  rowType: PropTypes.oneOf(['list', 'individual_cell', 'dynamic']).isRequired
}
export default RowItem
